export enum PathfindersFlags {
    CloneRestrictedPermissions = 'clone-restricted-permissions',
    SecurityGroupApprovalRequired = 'security-group-approval-required',
    HideSecurityGroupUsers = 'hide-security-group-users',
    SecurityGroupsAudit = 'security-groups-audit',
    FasterUserDetails = 'faster-user-details',
    AdminUserDetailsUserType = 'admin-user-details-user-type',
    ExpandedShiftLength = 'expanded-shift-length',
    PremiumBillRatesChangingSpecialtyFix = 'premium-bill-rates-changing-specialty-fix',
    DisablePipelinedMarginUpdate = 'disable-pipelined-margin-update',
    FacilityStateClassifications = 'facility-state-classifications',
    EnableAyaPaidBonusCoCApprovalWorkFlow = 'enable-aya-paid-bonus-CoC-approval-workflow',
    FixPayPackageShiftsInfo = 'fix-missing-pay-package-shift-info',
    EnableRTOMultiContractMessage = 'Enable_RTO_MultiContract_Message',
    HideExtraLinesContractRequestApprovalTable = 'hide_extralines_contractrequest_approval_table',
    EffectiveDateHistoryUTCToPTConversionFlag = 'effective-date-history-utc-to-pt-conversion',
    HousewareDuplicationCheck = 'houseware-duplication-check',
    NovaAccountManagersDealsSCMarginLinkFix = 'nova-account-managers-deals-sc-margin-link-fix',
    AddContractRequestFilterSubcontractorMargin = 'add-contract-request-filter-subcontractor-margin',
    SubMarginDaysLengthFix = 'sub-margin-days-length-fix',
    InsuranceEffectiveDateEnabled = 'insurance-effective-date-enabled',
    MinimumWageFacilityContractsChanges = 'minimum-wage-facility-contracts-changes',
    ContractRequestChangelogEffectiveDates = 'contractrequest-changelog-effectivedates',
    EnableInsuranceCosts2026View = 'enable-insurance-costs-2026-view',
    ContractRequestChangelogEmptyEffectiveDatesEditable = 'contractchangelog-empty-effectivedates-editable',
    McDetailPayPackageLanguageUpdate = 'mc-detail-pay-package-language-update',
    McDetailPayPackageCopyContent = 'mc-detail-pay-package-copy-content',
    HideMarginDetailsHourlyBreakdown = 'hide-margin-details-hourly-breakdown',
    QuickQuotePayPackageLanguageUpdate = 'quick-quote-pay-package-language-update',
    InsuranceTotalCostFix = 'insurance-total-cost-fix',
    MarginGridContractRequestV2 = 'margin-grid-contract-request-v2',
    OfferMarginLinkingEnabled = 'offer-margin-linking-enabled',
    DoNotShowDifferencesToTravelContracts = 'do-not-show-differences-to-travel-contracts',
    UseNewContractChangeTypeEndpoint = 'use-new-contract-change-type-endpoint',
    RedBannerContractRequestSentFix = 'red-banner-contract-request-sent-fix',
    QuickQuoteOtRemove = 'quick-quote-ot-remove',
    PinkCellOtBillFix = 'pink-cell-ot-bill-fix',
    FixClinicianBlurIssue = 'fix-clinician-blur-issue',
    AdminToolNewDesignEnabled = 'admin-tool-new-design-enabled',
    BulkUploadDesignEnabled = 'bulk-upload-design-enabled',
    FixPayPackageCopyContentIssue = 'fix-pay-package-copy-content-issue',
    ContractModEmailFormatFix = 'contract-mod-email-format-fix',
    EnableMoneyMovementInsuranceDaysFix = 'enable-money-movement-insurance-days-fix',
    SetMarginType = 'set-margin-type',
    FixRedBannerReadonlyIssue = 'fix-red-banner-readonly-issue',
    NonAlternatingShiftBannerHeightFix = 'non-alternating-shift-banner-height-fix',
    AddNewReimbursementPickleIconHoverFix = 'add-new-reimbursement-pickle-icon-hover-fix',
    WFDSimplifiedSampleMargin = 'wfd-simplified-sample-margin',
    SendAuxiliaryDocumentsIndividually = 'send-auxiliary-documents-individually',
    PipelinedMarginHintLinksFix = 'pipelined-margin-hint-links-fix',
    IsMcPristineFacilityEnabled = 'is-mc-pristine-facility-enabled',
    TravelRecruitingJobGridWithMarginType = 'travel-recruiting-job-grid-with-margin-type',
    FixedCalendarIconPosition = 'fixed-calendar-icon-position',
    SCMarginVacationAlertIconFix = 'subcontractor-margin-vacation-alert-icon-fix',
    RecalculateMarginAfterWeeksOrDaysChange = 'recalculate-margin-after-weeks-or-days-change'
}
